export const heroIncludes = [
  'The complete 6-volume system',
  '5 premium bonuses included',
  '350+ pages, 100% printable',
  'Ready-to-use scripts and templates',
  'Instant access — yours forever',
]

export const volumeTitles = [
  'Volume 1 — The Hypertrophy & Strength Blueprint',
  'Volume 2 — The Metabolic Engine & Fat Loss Protocols',
  'Volume 3 — Athletic Performance & Power Development',
  'Volume 4 — The Ultimate Visual Exercise Library',
  'Volume 5 — The Performance Data Tracker & Logs',
  'Volume 6 — Injury Prevention & Recovery Protocols',
]

export const painPoints = [
  { emoji: '⏰', text: 'It is 9 PM on Sunday and you are still staring at a blank spreadsheet, building next week from scratch.' },
  { emoji: '🤯', text: 'Hypertrophy or strength? Which periodization? What rep range for THIS client? Every choice is a guess.' },
  { emoji: '📉', text: 'Your clients plateau at week 6, lose motivation, and quietly disappear.' },
  { emoji: '💼', text: 'You coach 60+ hours a week and still make less than a friend working 40 in an office.' },
  { emoji: '💸', text: 'You look like "the guy at the gym", so people expect $50/hour instead of $150/hour.' },
  { emoji: '🗂️', text: 'Your programs, notes, and forms live in 15 different places and none of them agree.' },
]

export const features = [
  {
    title: 'The Hypertrophy & Strength Blueprint',
    pain: 'Pain: Guessing the programming',
    description: 'Full periodized 12-week program (phases 1-3), every exercise explained, progression formulas, auto-regulation, and a 30-day implementation roadmap.',
  },
  {
    title: 'The Metabolic Engine & Fat Loss Protocols',
    pain: 'Pain: Clients who yo-yo',
    description: 'Complete 12-week fat loss programming, deficit strategy, macro targets by body type, hunger management, and metabolic adaptation solutions.',
  },
  {
    title: 'Athletic Performance & Power Development',
    pain: 'Pain: No premium offer',
    description: 'Max strength and power conversion, Olympic lift progressions, plyometrics, sprint and agility work, plus performance testing standards.',
  },
  {
    title: 'The Ultimate Visual Exercise Library',
    pain: 'Pain: Explaining the same thing 50 times',
    description: '150+ exercises with form, common mistakes, coaching cues, variations, contraindications, and a print-ready format to hand to clients.',
  },
  {
    title: 'The Performance Data Tracker & Logs',
    pain: 'Pain: No proof of progress',
    description: 'Weekly logs, monthly periodization summaries, client dashboards, benchmarking, plateau diagnostics, and volume-load analytics.',
  },
  {
    title: 'Injury Prevention & Recovery Protocols',
    pain: 'Pain: Clients who break down',
    description: 'FMS movement screens, 15-minute daily mobility, pain-pattern strategies, return-to-play protocols, sleep and stress management.',
  },
]

export const bonuses = [
  {
    emoji: '📊',
    tag: 'Bonus #1',
    title: 'Automated Client Assessment Excel',
    description: 'Auto-calculates maintenance calories, macros, training zones, and strength benchmarks. Saves 10+ hours per client onboarded.',
  },
  {
    emoji: '📞',
    tag: 'Bonus #2',
    title: 'Discovery Call & Sales Scripts',
    description: '10 proven scripts, objection handling for price, time, and guarantee, and a call framework that lifts conversion from 15% to 40-50%.',
  },
  {
    emoji: '🥗',
    tag: 'Bonus #3',
    title: 'Nutrition & Supplementation Blueprints',
    description: 'What to eat, when, and how much, 15 five-ingredient recipes, an honest supplement guide, and an exact shopping list.',
  },
  {
    emoji: '✅',
    tag: 'Bonus #4',
    title: 'Weekly Habit & Recovery Checklists',
    description: 'Gamified adherence tracking for sleep, nutrition, training, and stress. Increases adherence 40-60%. Print it and hand it over.',
  },
  {
    emoji: '⚖️',
    tag: 'Bonus #5',
    title: 'Legal & Branding Starter Pack',
    description: 'Client waivers, service agreements, invoice templates, email signatures, and 50+ pre-designed social media graphics.',
  },
]

export const offerChecklist = [
  'The Personal Trainer System — 6 volumes (350+ pages)',
  'Bonus #1 — Automated Client Assessment Excel',
  'Bonus #2 — Discovery Call & Sales Scripts',
  'Bonus #3 — Nutrition & Supplementation Blueprints',
  'Bonus #4 — Weekly Habit & Recovery Checklists',
  'Bonus #5 — Legal & Branding Starter Pack',
  'Instant digital access — yours forever',
]

export const outcomes = [
  'Plan a 12-week phase in 30 minutes instead of a full Sunday.',
  'Cut 50+ hours of planning work every single month.',
  'Show clients real data instead of vague promises.',
  'Keep clients past week 6 because progress never stalls.',
  'Charge 40-60% more because your business finally looks elite.',
  'Work 35-40 hours a week and still grow your income.',
]

export const testimonials = [
  {
    quote: 'I was spending 8+ hours every Sunday planning workouts. With The Personal Trainer System I am done in 30 minutes, and my clients see better results because I use science-based periodization instead of guessing. I made back my investment 10x over.',
    name: 'Marcus T.',
    location: 'NYC',
  },
  {
    quote: 'I was not confident raising my prices because my business did not look professional. Now my clients get printed blueprints, tracking sheets, and recovery protocols. I raised my rates 40% and nobody hesitated.',
    name: 'Sarah M.',
    location: 'LA',
  },
  {
    quote: 'The data tracking module alone is worth the price. I can show clients exactly why they are progressing or plateauing. My retention went from 60% to 85%.',
    name: 'James R.',
    location: 'Chicago',
  },
]

export const faqs = [
  {
    question: 'Is this just another generic fitness program database?',
    answer: 'No. It is a complete business infrastructure: periodized training frameworks, nutrition protocols, recovery strategies, legal documents, data tracking, and scaling strategies — built specifically for Personal Trainers who want to systematize their practice.',
  },
  {
    question: 'Can I use this if I only train clients online?',
    answer: 'Absolutely. The data tracking module is ideal for online coaching — share progress dashboards digitally or print them. The system works equally well in person and online.',
  },
  {
    question: 'What if I am already established and have my own programs?',
    answer: 'This replaces the need to build programs from scratch and works as a benchmark against what you already use. Most established coaches find it more organized and more complete than the systems they built themselves.',
  },
  {
    question: 'Will this work for my niche (CrossFit, sports training, general population)?',
    answer: 'The core framework — periodization, progression, recovery — is universal. Volume 1 includes specialty add-ons for prenatal, postpartum, elderly clients, and post-injury rehab, so you have the foundation for any customization.',
  },
  {
    question: 'How long does implementation take?',
    answer: 'Most coaches deploy with clients within 1-2 weeks. Reading all 6 volumes takes 6-10 hours, and setup — organizing templates and adding your branding — takes another 2-3 hours.',
  },
  {
    question: 'What format is it in, and can I share it with my team?',
    answer: 'Everything is PDF: printable, editable, and shareable. No videos, no platforms, no subscriptions. The license covers individual use — contact us if you need team pricing.',
  },
]
